/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nb_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online number base converter. Convert numbers between binary, octal, decimal, and hexadecimal at once, with exact big-number support. Works in your browser.`)
};

const es_nb_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor gratuito de bases numéricas en línea. Convierte números entre binario, octal, decimal y hexadecimal a la vez, con soporte exacto de números grandes. Funciona en tu navegador.`)
};

const de_nb_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Zahlenbasis-Umrechner. Rechne Zahlen gleichzeitig zwischen Binär, Oktal, Dezimal und Hexadezimal um, mit exakter Unterstützung für große Zahlen. Funktioniert in deinem Browser.`)
};

const nl_nb_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online getalbasiscalculator. Converteer getallen tussen binair, octaal, decimaal en hexadecimaal tegelijk, met nauwkeurige ondersteuning voor grote getallen. Werkt in uw browser.`)
};

const fr_nb_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur de base numérique en ligne gratuit. Convertissez des nombres entre binaire, octal, décimal et hexadécimal à la fois, avec un support précis des grands nombres. Fonctionne dans votre navigateur.`)
};

const it_nb_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore di basi numeriche gratuito online. Converti numeri tra binario, ottale, decimale ed esadecimale contemporaneamente, con supporto esatto per numeri grandi. Funziona nel tuo browser.`)
};

const pt_br2_nb_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de bases numéricas online gratuito. Converta números entre binário, octal, decimal e hexadecimal de uma vez, com suporte exato a números grandes. Funciona no seu navegador.`)
};

const pt_nb_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de base de números online gratuito. Converta números entre binário, octal, decimal e hexadecimal em simultâneo, com suporte exato a números grandes. Funciona no seu navegador.`)
};

const ja_nb_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料オンライン数値ベース変換ツール。二進法、八進法、十進法、十六進法を相互変換できます。正確な大数値対応。ブラウザで動作します。`)
};

const zh_nb_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的在线进制转换器。一次性在二进制、八进制、十进制和十六进制之间转换数字，支持精确的大数运算。可在浏览器中使用。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nb_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nb_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nb_meta_description", locale)
	if (locale === "en") return en_nb_meta_description(inputs)
	if (locale === "es") return es_nb_meta_description(inputs)
	if (locale === "de") return de_nb_meta_description(inputs)
	if (locale === "nl") return nl_nb_meta_description(inputs)
	if (locale === "fr") return fr_nb_meta_description(inputs)
	if (locale === "it") return it_nb_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_nb_meta_description(inputs)
	if (locale === "pt") return pt_nb_meta_description(inputs)
	if (locale === "ja") return ja_nb_meta_description(inputs)
	return zh_nb_meta_description(inputs)
};